export * from './error-base-page.component';
